import React from 'react';
import loadingImg from '../assets/images/Loader.gif';

const LoginLoader = ({ setLoggingIn }) => {
  return (
    <div className='loaderWraper'>
      <div className='loaderContent'>
        <img src={loadingImg} className='loadingImg' alt='loadfing' />
        <p className='loadertext msgForPortalLogin'>
          Welcome user, Please wait while we are taking you to the dashboard.
          Make sure you've logged yourself in the extension. If not, then login
          to the extension and then refresh this page.
        </p>
      </div>
    </div>
  );
};

export default LoginLoader;
